// Kwiki lanes: recently played (device) — ids newest-first, max 20.
const KEY = "wall_recent_tracks";
export const readRecent = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
export const pushRecent = (itemId) => {
  const next = [itemId, ...readRecent().filter((id) => id !== itemId)].slice(0, 20);
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
};
